(function ($, undefined) {
    var attachedMouse = false;
    var dataKey = 'tooltip';
    var cursorX, cursorY;
    var cursorAdjustedX, cursorAdjustedY;
    var currentMouseOver;
    var defaultOptions = {
        'content': null,
        'track': true
    };
    var tooltipContainer;

    var getOptions = function ($anchor) {
        return $anchor.data(dataKey);
    };

    var cursorPosition = function (e) {
        e = e || window.event;
        var cursor = { x: 0, y: 0 }
        if (e.pageX || e.pageY) {
            cursor.x = e.pageX;
            cursor.y = e.pageY;
        } else {
            var de = document.documentElement;
            var b = document.body;
            cursor.x = e.clientX + (de.scrollLeft || b.scrollLeft) - (de.clientLeft || 0);
            cursor.y = e.clientY + (de.scrollTop || b.scrollTop) - (de.clientTop || 0);
        }
        return cursor;
    };

    var mouseMove = function (e) {
        if (!!tooltipContainer && tooltipContainer.css('display') != 'none') {
            var cursor = cursorPosition(e);
            cursorX = cursor.x;
            cursorY = cursor.y;
            cursorAdjustedX = cursorX + 15;
            cursorAdjustedY = cursorY - 20;

            clampTooltip();
        }
    };

    var updateContent = function ($anchor) {

        var options = getOptions($anchor);

        // Check the content source
        if (options.content == null) {

            // Look for a title attribute
            var title = $anchor.attr('title');            
            
            // Look for a child element, with tooltip html            
            var html = $anchor.find("> .tooltip-html");

            // Only set the content coming from title once it's been set again since it is removed
            if (html.length > 0) {
                options.content = html.html();
                options.html = options.content;
            }
            else if (title != undefined && title != '') {
                options.html = $anchor.attr('title');
                $anchor.removeAttr('title');
            }
        } else {
            if (typeof options.content == 'string') {
                options.html = options.content;
            } else if (typeof options.content == 'object') {
                options.html = $('<div>').append($(options.content).clone(false).css('display', '')).remove().html();
            } else if (typeof options.content == 'function') {
                options.html = options.content($anchor);
            }
        }

        return options.html;
    };

    var setContent = function ($anchor, html) {
        var options = getOptions($anchor);
        updateContent($anchor);
        tooltipContainer.html(html);
    };

    var startTooltip = function () {        
        var $anchor = $(this);
        currentMouseOver = $anchor;

        var options = getOptions($anchor);
        if (options.customCssClass != null) {
            tooltipContainer.attr("class", "u-tooltips-a " + options.customCssClass);
        }
        else {
            tooltipContainer.attr("class", "u-tooltips-a");
        }
        updateContent($anchor);
        if (options.html != null) {
            setContent($anchor, options.html);
            show();
        }
    };

    var endTooltip = function () {
        var $anchor = $(this);
        currentMouseOver = null;

        hide();
    };

    var show = function () {
        if (!Cobalt.detectIsOnMobile()) {
            tooltipContainer.show();
        }
    };

    var hide = function () {
        tooltipContainer.hide();
    };

    var clampTooltip = function () {
        if (tooltipContainer === undefined) return;

        var container = tooltipContainer[0];
        if (container === undefined) return;

        var x = cursorX;
        var y = cursorY;
        var ax = cursorAdjustedX;
        var ay = cursorAdjustedY;
        var de = document.documentElement;
        var body = document.body;

        //$.info(["y: " + y, "y + container.offsetHeight: " + (y + container.offsetHeight), "container.offsetHeight: " + container.offsetHeight, "de.clientHeight: " + de.clientHeight, "body.scrollTop: " + body.scrollTop, "de.scrollTop: " + de.scrollTop]);
        if (y + container.offsetHeight > de.clientHeight + body.scrollTop + de.scrollTop) {
            var ydiff = (de.clientHeight + body.scrollTop + de.scrollTop) - (y + container.offsetHeight);
            ay += ydiff;
        }
        if (x + container.offsetWidth + 27 > de.clientWidth + body.scrollLeft + de.scrollLeft) {
            ax -= container.offsetWidth + 27;
        }

        container.style.left = "" + (ax) + "px";
        container.style.top = "" + (ay) + "px";
    };

    var initializeAnchor = function ($anchor) {        
        $anchor.on('mouseover', startTooltip);
        $anchor.on('mouseout click', endTooltip);

        $(document).keyup(function(e) {
            // When escape is pressed
            if (e.keyCode == 27) {
                endTooltip();
            }
        });
    };

    var createTooltipContainer = function () {
        var $tooltipContainer =
            $('<div>')
                .attr('id', 'tooltip-container')
                .attr('class', 'u-tooltips-a')
                .css('position', 'absolute')
                .css('display', 'none');

        return $tooltipContainer;
    };

    $.fn.tooltip = function (options) {
        if (!this || this.length < 1) {
            return;
        }
        if (!attachedMouse) {
            $(document).mousemove(mouseMove);
            attachedMouse = true;
        }

        if (!tooltipContainer) {
            tooltipContainer = createTooltipContainer();
            tooltipContainer.appendTo(document.body);
        }

        return this.each(function () {
            var $anchor = $(this);            
            var data = $anchor.data(dataKey);
            if (data == undefined) {
                var opts = $.extend({}, defaultOptions, options);

                // Custom tooltip container class support
                if (!opts.customCssClass)
                    opts.customCssClass = $(this).attr("data-tooltip-class");
                $anchor.data(dataKey, opts);
                initializeAnchor($anchor);
            }
        });
    };
})(jQuery);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.JQuery.Tooltip.js